import { css } from '@emotion/react';
import { MEDIA_MAX_SM } from './breakpoints';

export const globalStyles = css`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video,
  button,
  input,
  select,
  textarea {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-family:
      'Inter',
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      'Helvetica Neue',
      Arial,
      sans-serif;
    text-rendering: optimizeLegibility;
  }

  html {
    box-sizing: border-box;
  }

  body {
    line-height: 1;
    background: var(--background-01);
  }

  ol,
  ul {
    list-style: none;
  }

  [class^='lc-'] {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family:
      'Inter',
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      'Helvetica Neue',
      Arial,
      sans-serif;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  [class^='lc-Toast-module__toast'] {
    max-width: 600px;
  }

  [class*='lc-FieldError-module__field-error'] {
    text-align: left;
    white-space: pre-line;
  }

  ${MEDIA_MAX_SM} {
    input {
      font-size: 16px !important;
    }
  }
`;

export const ellipsis = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
